import { Center, Container, Heading, Text, Box, Flex } from '@chakra-ui/react';
import Tag from '../Tags/Simple';

export default function QuestionnaireHeader({
 tagLabel,
 heading,
 description,
 overline,
 children,
}) {
 return (
  <Center
   bg='white'
   borderBottom={['1px solid #E5E5E5', 'unset']}
   px={{ xl: '86px', '2xl': 'unset' }}
  >
   <Container maxW={'1280px'} p={0} overflowX='hidden'>
    <Flex h='174px' px={['24px', 'unset']} justify='space-between' align='center'>
     <Box>
      {tagLabel && <Tag label={tagLabel} />}

      <Heading
       fontSize={['20px', '22px']}
       lineHeight='normal'
       letterSpacing='-0.6px'
       m={['4px 0 8px', '12px 0 16px']}
      >
       {heading}
      </Heading>

      <Text
       fontSize={['13px', '16px']}
       lineHeight='22px'
       letterSpacing='0.17px'
       color='#000'
       position={'relative'}
       display={['none', 'block']}
       _after={
        overline
         ? {
            content: "''",
            width: 'full',
            height: '1px',
            position: 'absolute',
            top: '-6px',
            left: 0,
            bg: '#000',
            zIndex: 1,
           }
         : {}
       }
       dangerouslySetInnerHTML={{ __html: description }}
      />
     </Box>
     {children}
    </Flex>
   </Container>
  </Center>
 );
}
